import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {headTitle} from 'shells/document/head-title';

import type {ReportURLParams} from '../../reports/report-types';

import {useGetLandingPage, useUpdatePage} from '../graphql/hooks';

import {LandingPageEditor} from './landing-page-editor';
import {LandingPagePageContent} from './landing-page-page-content';

type Props = ContextRouter & {
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    id: string;
};

export function LandingPagePage(props: Props) {
    const {id, ...restProps} = props;
    const activeTab = props.match.params.tab;

    const {page, isLoading, errorMessage} = useGetLandingPage(id);

    const {updatePage} = useUpdatePage();
    const onUpdatePage = (input: {name?: string | null | undefined; beeBodyJson?: string}) => {
        return updatePage({
            ...input,
            pageId: id,
        });
    };

    return (
        <>
            <Helmet>
                <title>{headTitle(page ? `Page • ${page.name}` : 'Page')}</title>
            </Helmet>
            {activeTab === 'editor' && page ? (
                <LandingPageEditor
                    page={page}
                    onUpdatePage={(beeContentJson: string) =>
                        onUpdatePage({beeBodyJson: beeContentJson})
                    }
                />
            ) : (
                <LandingPagePageContent
                    {...restProps}
                    page={page}
                    isLoading={isLoading}
                    errorMessage={errorMessage}
                    onUpdatePage={(name?: string | null) => onUpdatePage({name})}
                />
            )}
        </>
    );
}
